import React, { useState, useEffect } from "react";
import { GoUnverified, GoVerified } from "react-icons/go";
import Utils from "../../utils/utils";

const ProfileDetails = ({ student }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { avatar } = student;

  useEffect(() => {
    setIsVisible(true); // Show the component with a slide-in effect
  }, []);

  return (
    <div
      className={`p-2 border rounded-lg shadow-sm w-full transition-transform duration-700 ease-in-out transform ${
        isVisible
          ? "translate-x-0 opacity-100"
          : "translate-x-[-100%] opacity-0"
      }`}
      key="ProfileDetails"
      bkl="ProfileDetails"
    >
      <div className="mt-1 md:flex mb-4">
        <div
          className="relative h-[100px] w-[100px] flex justify-center items-center"
          bkl="StudentAvatar"
        >
          <div className="flex justify-center items-center space-x-4 rounded">
            <div className="relative">
              {avatar ? (
                <img
                  alt="Avatar"
                  src={avatar}
                  className="rounded-full w-20 h-20"
                  loading="lazy"
                />
              ) : (
                <div
                  className={`w-16 h-16 rounded-full text-2xl font-semibold flex justify-center tracking-[1px] items-center overflow-hidden bg-pink-700 text-white `}
                >
                  {Utils.getUserAvatar(student.name)}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2 justify-center ml-4">
          <div className="flex gap-2 items-center flex-wrap">
            <h1 className="font-bold text-2xl">{student.name}</h1>
            <div className="text-gray-600 mb-3 flex items-centerfont-semibold text-sm">
              {student.verified ? (
                <>
                  {" "}
                  <GoVerified
                    style={{ color: "green", strokeWidth: 1.5 }}
                    className="mr-2"
                  />
                  <div className="badge text-xs text-green-800 badge-outline">
                    Verified
                  </div>
                </>
              ) : (
                <>
                  <GoUnverified style={{ color: "red" }} className="mr-2" />
                  <div className="badge text-xs text-red-600 badge-outline">
                    Not Verified
                  </div>
                </>
              )}
            </div>
          </div>
          <p className="text-sm font-semibold">{student.email}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 z-30">
        <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
          <div className="flex justify-between items-center">
            <p className="text-[#0A0103] px-3 font-semibold text-[14px] leading-6">
              Name
            </p>
          </div>
          <div>
            <input
              type="string"
              className="bg-inherit w-full border-none px-3 py-2 truncate"
              value={student.name}
              disabled
            />
          </div>
        </div>

        <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
          <div className="flex justify-between items-center">
            <p className="text-[#0A0103] px-3 font-semibold text-[14px] leading-6">
              Phone number
            </p>
          </div>
          <div>
            <input
              type="text"
              maxLength="10"
              minLength="10"
              pattern="^\d{10}$"
              placeholder="Enter 10 digit phone number"
              className="bg-inherit w-full border-none px-3 py-2 truncate"
              value={student.mobileNumber}
              disabled
            />
          </div>
        </div>

        <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
          <div className="flex justify-between items-center">
            <p className="text-[#0A0103] px-3 font-semibold text-[14px] leading-6">
              Aadhaar Number
            </p>
          </div>
          <div>
            <input
              type="text"
              maxLength="10"
              minLength="10"
              pattern="^\d{10}$"
              placeholder="Enter 10 digit phone number"
              className="bg-inherit w-full border-none px-3 py-2 truncate"
              value={student.aadhaar ? student.aadhaar : "Profile Incomplete!"}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;

// <div className="grid grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 z-30">
// <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
//   <div className="flex justify-between items-center">
//     <p className="text-[#0A0103] px-3  font-semibold text-[14px] leading-6 ">
//       Name
//     </p>
//     {/* <p className="text-[#3470E4] cursor-pointer text-[12px] font-semibold leading-4 hover:text-blue-600/75">
//       EDIT
//     </p> */}
//   </div>
//   <div className="">
//     <input
//       type="string"
//       className="bg-inherit w-[100%] border-none px-3 py-2 truncate"
//       value={student.name}
//       disabled
//     />
//   </div>
//   <div className="flex flex-row-reverse">
//     {/* <button
//       className="rounded-lg gap-[10px] text-[#FFFFFF]  bg-[#3470E4] bg-blue-700 hover:bg-blue-800 uppercase hidden uppercase  cursor-pointer px-4 py-2"
//       type="button"
//     >
//       Save
//     </button> */}
//   </div>
// </div>

//   <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
//     <div className="flex justify-between items-center">
//       <p className="text-[#0A0103] px-3  font-semibold text-[14px] leading-6 ">
//         Phone number
//       </p>
//       {/* <p className="text-[#3470E4] cursor-pointer text-[12px] font-semibold leading-4 hover:text-blue-600/75">
//         EDIT
//       </p> */}
//     </div>
//     <div className="">
//       <input
//         type="text"
//         maxLength="10"
//         minLength="10"
//         pattern="^\d{10}$"
//         placeholder="Enter 10 digit phone number"
//         className="bg-inherit w-[100%] border-none px-3 py-2 truncate"
//         value={student.mobileNumber}
//         disabled
//       />
//     </div>
//     {/* <div className="flex flex-row-reverse">
//       <button
//         className="rounded-lg gap-[10px] text-[#FFFFFF]  bg-[#3470E4] hover:bg-blue-800 hidden uppercase  cursor-pointer px-4 py-2"
//         type="button"
//       >
//         Save
//       </button>
//     </div> */}
//   </div>

//   <div className="border bg-[#FFFFFF] rounded-lg p-3 min-w-[300px]">
//     <div className="flex justify-between items-center">
//       <p className="text-[#0A0103] px-3  font-semibold text-[14px] leading-6 ">
//         Aadhaar Number
//       </p>
//       {/* <p className="text-[#3470E4] cursor-pointer text-[12px] font-semibold leading-4 hover:text-blue-600/75">
//         EDIT
//       </p> */}
//     </div>
//     <div className="">
//       <input
//         type="text"
//         maxLength="10"
//         minLength="10"
//         pattern="^\d{10}$"
//         placeholder="Enter 10 digit phone number"
//         className="bg-inherit w-[100%] border-none px-3 py-2 truncate"
//         value={student.aadhaar ? student.aadhaar : "Profile Incomplete !"}
//         disabled
//       />
//     </div>
//     <div className="flex flex-row-reverse">
//       <button
//         className="rounded-lg gap-[10px] text-[#FFFFFF]  bg-[#3470E4] hover:bg-blue-800 uppercase hidden uppercase  cursor-pointer px-4 py-2"
//         type="button"
//       >
//         Save
//       </button>
//     </div>
//   </div>
// </div>;
